import { Component, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslocoDirective } from '@jsverse/transloco';
import {
  CheckboxFieldWithErrorComponent,
  DatepickerFieldWithErrorComponent,
  FileUploadFieldWithErrorComponent,
  FormSectionComponent,
  TextFieldWithErrorComponent
} from 'htx-ui-library';
import { FormErrorMessagesService } from '../../../../services/form/form-error-messages.service';

@Component({
  selector: 'app-registration-step-3-verification',
  imports: [
    ReactiveFormsModule,
    TranslocoDirective,
    FormSectionComponent,
    TextFieldWithErrorComponent,
    DatepickerFieldWithErrorComponent,
    FileUploadFieldWithErrorComponent,
    CheckboxFieldWithErrorComponent
  ],
  templateUrl: './registration-step-3-verification.component.html',
  styleUrl: './registration-step-3-verification.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RegistrationStep3VerificationComponent {
  readonly verificationForm = input.required<FormGroup>();
  readonly verificationFormFieldLabels = input.required<{ [key: string]: string }>();
  readonly errorMessagesService = inject(FormErrorMessagesService);
}
